<template>
  <div class="content">
    <ul class="list-unstyled team-members">
      <slot name="list"></slot>
    </ul>
  </div>
</template>